import { render, staticRenderFns } from "./clothDialog.vue?vue&type=template&id=951c97ba"
import script from "./clothDialog.vue?vue&type=script&lang=js"
export * from "./clothDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports